module.exports = __webpack_public_path__ + "img/agreement.8575fdf4.svg";